import { ExternalPlatform } from '@shared/types/conversation';
import { FaCommentSms } from 'react-icons/fa6';
import { MdOutlineEmail } from 'react-icons/md';

type ExternalPlatformIconProps = {
  platform: ExternalPlatform;
  size?: number;
};

export function ExternalPlatformIcon({
  platform,
  size = 16,
}: ExternalPlatformIconProps) {
  switch (platform) {
    case ExternalPlatform.SLACK:
      return <img width={size} height={size} src="/slack.png" alt="Slack" />;
    case ExternalPlatform.MICROSOFT_TEAMS:
      return (
        <img
          width={size}
          height={size}
          src="/teams.png"
          alt="Microsoft Teams"
        />
      );
    case ExternalPlatform.ASSISTANT_EMAIL:
      return <MdOutlineEmail size={size} aria-label="Email" />;
    case ExternalPlatform.SMS:
      return <FaCommentSms size={size} aria-label="SMS" />;
    default:
      return null;
  }
}

export function getExternalPlatformLabel(platform: ExternalPlatform): string {
  switch (platform) {
    case ExternalPlatform.SLACK:
      return 'Slack';
    case ExternalPlatform.MICROSOFT_TEAMS:
      return 'Microsoft Teams';
    case ExternalPlatform.ASSISTANT_EMAIL:
      return 'Email';
    case ExternalPlatform.SMS:
      return 'SMS';
    default:
      return '';
  }
}
